module.exports = __webpack_public_path__ + "img/logoHorizontal.e9ac0664.png";